// // File: dateUtils.js
import NepaliDate from 'nepali-date-converter';

const convertDateToBS = (dateInAd) => {
    const dateInBS = new NepaliDate(new Date(dateInAd));
    const year = dateInBS.getYear();
    const month = dateInBS.getMonth() + 1;
    const date = dateInBS.getDate();
    const formattedDate = `${year}-${month}-${date}`;
    return formattedDate;
};

const convertDateToAD = (dateInBS) => {
    const dateInAD = (new NepaliDate(dateInBS)).getAD();
    const {year, date, month} = dateInAD
    const formattedDate = `${year}-${month+1}-${date}`;
    return new Date(formattedDate);
};

export { convertDateToAD, convertDateToBS};
